module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "label": "NEW",
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "USER",
      "visible": _vm.showDialog,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addUser.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewUser.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "accountHead"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "accountHead"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), (!this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "username"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "userName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Password', {
    attrs: {
      "type": "password",
      "id": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "rePassword"
    }
  }, [_vm._v("Re-password"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Password', {
    attrs: {
      "type": "rePassword",
      "id": "rePassword"
    },
    model: {
      value: (_vm.rePassword),
      callback: function($$v) {
        _vm.rePassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "rePassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Role"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "filter": true,
      "options": _vm.roleLists,
      "id": "role",
      "optionLabel": "name",
      "placeholder": "Select Role",
      "showClear": true
    },
    model: {
      value: (_vm.roleId),
      callback: function($$v) {
        _vm.roleId = $$v
      },
      expression: "roleId"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-grid",
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('div', {
    staticClass: "p-col-6"
  }, [_c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('label', [_vm._v("Two-Factor Authentication")]), _vm._v(" "), _c('div', {
    staticClass: "flex align-items-center"
  }, [_c('Checkbox', {
    attrs: {
      "binary": true,
      "disabled": true
    },
    model: {
      value: (_vm.enable2FA),
      callback: function($$v) {
        _vm.enable2FA = $$v
      },
      expression: "enable2FA"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2"
  }, [_vm._v("\n                      " + _vm._s(_vm.enable2FA ? 'Enabled' : 'Disabled') + "\n                      "), _c('span', {
    style: ({
      color: _vm.enable2FA ? 'green' : 'red'
    })
  }, [_vm._v("\n                        (" + _vm._s(_vm.enable2FA ? 'Active' : 'Inactive') + ")\n                      ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-col-6"
  }, [_c('div', {
    staticClass: "flex flex-col gap-2"
  }, [_c('label', [_vm._v("Enable Login Time")]), _vm._v(" "), _c('div', {
    staticClass: "flex align-items-center"
  }, [_c('Checkbox', {
    attrs: {
      "binary": true
    },
    model: {
      value: (_vm.enableLoginTime),
      callback: function($$v) {
        _vm.enableLoginTime = $$v
      },
      expression: "enableLoginTime"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-2"
  }, [_vm._v("\n                      " + _vm._s(_vm.enableLoginTime ? 'Enabled' : 'Disabled') + "\n                      "), _c('span', {
    style: ({
      color: _vm.enableLoginTime ? 'green' : 'red'
    })
  }, [_vm._v("\n                        (" + _vm._s(_vm.enableLoginTime ? 'Active' : 'Inactive') + ")\n                      ")])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "openingBalance"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('RadioButton', {
    attrs: {
      "id": "active",
      "name": "ACTIVE",
      "value": "ACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "inactive",
      "name": "INACTIVE",
      "value": "INACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "inactive"
    }
  }, [_vm._v("Inactive")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Email"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "accountHead"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Store"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "filter": true,
      "options": _vm.warehouseLists,
      "id": "role",
      "optionLabel": "name",
      "placeholder": "Select Store",
      "showClear": true
    },
    model: {
      value: (_vm.warehouseId),
      callback: function($$v) {
        _vm.warehouseId = $$v
      },
      expression: "warehouseId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v("Counter"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "filter": true,
      "options": _vm.counterLists,
      "id": "role",
      "optionLabel": "name",
      "placeholder": "Select Counter",
      "showClear": true
    },
    model: {
      value: (_vm.counterId),
      callback: function($$v) {
        _vm.counterId = $$v
      },
      expression: "counterId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "crmCustomerWise"
    }
  }, [_vm._v("Customer Category")]), _vm._v(" "), _c('MultiSelect', {
    attrs: {
      "options": _vm.crmCustomerOptions,
      "optionLabel": "label",
      "placeholder": "Select Categories",
      "display": "chip",
      "id": "crmCustomerWise"
    },
    model: {
      value: (_vm.crmCustomerWises),
      callback: function($$v) {
        _vm.crmCustomerWises = $$v
      },
      expression: "crmCustomerWises"
    }
  })], 1)])])], 1), _vm._v(" "), _c('userList', {
    on: {
      "delete-user": _vm.deleteUser,
      "edit-user": _vm.updateUser
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-711fdcf7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/user.vue
// module id = 2307
// module chunks = 0